import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "this-is-the-start-of-a-beautiful-friendship-span-roleimg-aria-labellove️span"
    }}>{`This is the start of a beautiful friendship `}<span role="img" aria-label="love">{`❤️`}</span></h2>
    <div className="copy-thanks">Thanks for signing up to my email list <span role="img" aria-label="letter">💌</span>  You're the best! <span role="img" aria-label="Horns">🤘</span> My robots are sending you a welcome email. Here are some extra bonuses, if you want <span role="img" aria-label="finger-down">👇</span></div>
    <ul>
      <li parentName="ul"><img parentName="li" {...{
          "src": "https://goviral.growthtools.com/images/bullets/1.png",
          "alt": "1"
        }}></img>{` Free copy of Why Programmers Work at Night `}<span role="img" aria-label="owl">{`🦉`}</span></li>
      <li parentName="ul"><img parentName="li" {...{
          "src": "https://goviral.growthtools.com/images/bullets/2.png",
          "alt": "2"
        }}></img>{` 29 videos on React Basics `}<span role="img" aria-label="film"></span></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      